import React, { Component } from "react";
import PropTypes from "prop-types";
import { Chip } from "material-ui";
import { KeyboardArrowRight } from "material-ui-icons";
import classNames from "classnames";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    row: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap"
    },
    chip: {
        margin: `0 ${theme.spacing.unit / 2}px`
    },
    separator: {
        margin: "auto 0"
    }
});

class UserLanguages extends Component {
    static propTypes = {
        languages: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        className: PropTypes.string,
        t: PropTypes.func.isRequired
    };

    renderLanguages(languages) {
        const { classes, t } = this.props;
        return languages.map(({ language }) => {
            const l = "languages.codes." + language;
            return (
                <Chip label={t(l)} key={language} className={classes.chip} />
            );
        });
    }
    render() {
        const { classes, languages, className } = this.props;

        const learningLanguages = languages.filter(l => l.isLearning);
        const masteredLanguages = languages.filter(l => !l.isLearning);

        return (
            <div className={classNames(classes.row, className)}>
                {this.renderLanguages(masteredLanguages)}
                <KeyboardArrowRight className={classes.separator} />
                {this.renderLanguages(learningLanguages)}
            </div>
        );
    }
}

export default withStylesAndTranslation(UserLanguages, styleSheet);



// WEBPACK FOOTER //
// ./src/components/UserLanguages.jsx